import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, RouterStateSnapshot } from "@angular/router";
import { IAppConfigurationProvider } from "../interfaces/IAppConfigurationProvider";
import { IUserLoginService } from "../interfaces/IUserLoginService";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    constructor(private userService: IUserLoginService,
                private appConfigurationProvider: IAppConfigurationProvider) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
        let result = await this.userService.checkToken();

        if (!result) {
            // Redirigez l'utilisateur vers la page de connexion si non authentifié
            await this.appConfigurationProvider.navigateToConnection();
            return false;
        } else {
            return true;
        }
    }
}